export const loadFilesAction = () => ({
  type: 'nuxiba_loadFiles',
})